module.exports = __webpack_public_path__ + "static/media/DDIP_Data-Phases.8a1b53b7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/csv/DDIP_Data-Phases.csv
// module id = 218
// module chunks = 0